import { Pencil2Icon } from '@radix-ui/react-icons'
import React, { useState } from 'react'

import { useGetBrokersUnprocessedEnrollmentsId } from 'utils/web_api'

import EditEnrollmentSheet from './EditEnrollmentSheet'
import { getFormattedDate } from '../../utils'
import { useGetEnrollmentCoverages } from '../hooks/enrollments/useGetEnrollmentCoverages'
import { Banner } from '../reusable/Banner'

type CoveragesProps = {
  memberId: string
  enrollmentId: string
  isEditEnrollmentV2Enabled: boolean
  editCoveragesPath: string
}

function Coverages ({
  memberId,
  enrollmentId,
  isEditEnrollmentV2Enabled,
  editCoveragesPath,
}: CoveragesProps) {
  const [isEditOpen, setIsEditOpen] = useState(false)

  const {
    data: enrollment,
    isLoading,
  } = useGetBrokersUnprocessedEnrollmentsId(enrollmentId)

  const {
    data: coverages,
    isLoading: isCoveragesLoading,
    isError: isCoveragesError,
  } = useGetEnrollmentCoverages({ enrollmentId, memberId })

  if (isLoading || isCoveragesLoading) {
    return (
      <div className='animate-pulse flex w-[400px] min-h-[100px]'>
        <div className='bg-slate-50 rounded-md my-2 w-[100%]' />
      </div>
    )
  }

  if (isCoveragesError) {
    return (
      <Banner className='mb-4' titleText='Something went wrong' type='critical'>
        <p>
          An error occurred while loading coverages. Please contact support for
          assistance.
        </p>
      </Banner>
    )
  }

  return (
    <div className='flex items-center mb-4'>
      <div className='bg-slate-50 p-4 rounded-lg text-sm grow'>
        <div className='mb-2'>
          <div className='grid grid-cols-9'>
            {coverages?.length
              ? (
                <>
                  <div className='font-semibold text-slate-600 col-span-4'>
                    Participants
                  </div>
                  <div className='font-semibold text-slate-600 col-span-4'>
                    Coverage
                  </div>
                </>
                )
              : (
                <div className='font-semibold text-slate-600 col-span-8'>
                  No coverages
                </div>
                )}
            {isEditEnrollmentV2Enabled
              ? (
                <div
                  onClick={() => setIsEditOpen(true)}
                  className='flex justify-end cursor-pointer'
                >
                  <Pencil2Icon className='w-5 h-5' />
                </div>
                )
              : (
                <a href={editCoveragesPath} className='flex justify-end'>
                  <Pencil2Icon className='w-5 h-5' />
                </a>
                )}
          </div>
          {/* List of participants */}
          <div className='space-y-2 mt-2'>
            {coverages?.map((coverage, index) => (
              <div key={index} className='grid grid-cols-9'>
                <div className='col-span-4'>
                  <span>{coverage.full_name}</span> ({coverage.relationship})
                </div>
                <div className='col-span-4'>
                  {getFormattedDate(coverage.start_date, { timeZone: 'UTC' })} -{' '}
                  {getFormattedDate(coverage.end_date, { timeZone: 'UTC' })}
                </div>
                <div className='w-5 h-5' />
              </div>
            ))}
          </div>
        </div>
      </div>
      {enrollment && (
        <EditEnrollmentSheet
          isOpen={isEditOpen}
          setIsOpen={setIsEditOpen}
          enrollment={enrollment}
          memberId={memberId}
        />
      )}
    </div>
  )
}

export default Coverages
